<template>
  <div class="card mb-25 border-0 rounded-0 bg-white edit-course-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="createSentNote">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Zone (ENVOIE) :
              </label>
              <v-select
                class="custom-select-height"
                :options="zoneEnvoieList"
                v-model="zoneSend"
                label="zone_name"
                @update:modelValue="handleZoneSelection"
                placeholder="Select a zone"
              >
                <!-- Corrected option template -->
                <template #option="{ zone_name, nb_colis }">
                  <span>{{ zone_name }} - {{ nb_colis }} Colis</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agence (ENVOIE) :
              </label>
              <v-select
                class="custom-select-height"
                :options="agencesEnvoieList"
                v-model="sendAgency"
                label="name"
                @update:modelValue="handleAgencySelection"
                placeholder="Select a zone"
              >
                <!-- @input="getAgencyRecept(sendAgency.id)" -->

                <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>
              </v-select>
            </div>
          </div>
          <hr />

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agence (RECEPTION) :
              </label>
              <v-select
                class="custom-select-height"
                :options="receptAgencies"
                v-model="receptAgency"
                label="name"
              >
                <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <button class="btn btn-primary" type="submit">Ajouter</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted, ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const agencesEnvoieList = ref([]);
    const zoneEnvoieList = ref([]);
    const receptAgencies = ref([]);
    const zoneSend = ref<any | null>(null);
    const sendAgency = ref<any | null>(null);
    const receptAgency = ref<any | null>(null);
    const codeColis = ref("");
    const isLoader = ref(false);
    const agency = ref({});

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/ZoneSent`);
        if (response && response.data) {
          console.log(response.data);
          zoneEnvoieList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function getAgencySend(id_zone: number) {
      sendAgency.value = null;
      receptAgency.value = null;
      receptAgencies.value = [];
      const res = await api.get(`/api/auth/AgencySent/${id_zone}`);
      agencesEnvoieList.value = res.data;
    }

    async function getAgencyRecept(id_agency: number) {
      receptAgency.value = null;
      const res = await api.get(`/api/auth/AgencyRecept/${id_agency}`);
      receptAgencies.value = res.data;
    }

    const handleZoneSelection = (zone: any) => {
      if (zone?.id_zone) {
        getAgencySend(zone.id_zone);
      }
    };

    const handleAgencySelection = (agency: any) => {
      if (agency?.id) {
        getAgencyRecept(agency.id);
      }
    };

    async function createSentNote() {
      if (!zoneSend.value || !sendAgency.value || !receptAgency.value) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }

      const data = new FormData();
      data.append("User_ID", String(user?.id ?? ""));
      data.append("sending_zone", String(zoneSend.value.id_zone));
      data.append("reception_zone", String(receptAgency.value.id_zone));
      data.append("sending_agency", String(sendAgency.value.id));
      data.append("reception_agency", String(receptAgency.value.id));
      data.append("sending_zone_name", zoneSend.value.zone_name);
      data.append("reception_zone_name", receptAgency.value.zone_name);
      data.append("sending_agency_name", sendAgency.value.name);
      data.append("reception_agency_name", receptAgency.value.name);
      data.append("type", "SIMPLE");

      isLoader.value = true;

      try {
        const res = await api.post(`/api/auth/Add_SentNote`, data);

        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "EditSentNotePage",
            params: { refNote: res.data.SNRef.note_ref, id: res.data.SNRef.id },
          });
          window.open(routeData.href, "_blank");
        } else {
          showToast("Erreur lors de la création du bon d'envoi", "error");
        }
      } catch (error) {
        showToast("Erreur lors de la création du bon d'envoi", "error");
      } finally {
        isLoader.value = false;
      }
    }

    return {
      agencesEnvoieList,
      zoneEnvoieList,
      receptAgencies,
      zoneSend,
      sendAgency,
      receptAgency,
      codeColis,
      isLoader,
      agency,

      getAgencySend,
      getAgencyRecept,
      createSentNote,
      handleZoneSelection,
      handleAgencySelection,
    };
  },
});
</script>
